import { render, staticRenderFns } from "./FormatAssetManagement.vue?vue&type=template&id=5bd651a6&scoped=true"
import script from "./FormatAssetManagement.vue?vue&type=script&lang=js"
export * from "./FormatAssetManagement.vue?vue&type=script&lang=js"
import style0 from "./FormatAssetManagement.vue?vue&type=style&index=0&id=5bd651a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd651a6",
  null
  
)

export default component.exports